import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PREDICTIONS_QUERY_KEYS } from "@/features/predictions/constants/queryKeys";
import { preferencesService } from "@/features/predictions/services/preferences.service";
import type { MyPronosticsPreferences } from "@/features/predictions/types/preferences.type";

export const useJoinCompetitionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<MyPronosticsPreferences, Error, void>({
    mutationFn: () => preferencesService.joinCompetition(),
    onSuccess: (preferences) => {
      queryClient.setQueryData(PREDICTIONS_QUERY_KEYS.myPreferences(), preferences);
      queryClient.invalidateQueries({ queryKey: ["predictions", "ranking", "global"] });
      queryClient.invalidateQueries({ queryKey: PREDICTIONS_QUERY_KEYS.myStats() });
    },
  });
};
